import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components/shared';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class PhysicianTypesLookupService extends ApiAutoCompleteService {
  constructor(private service: CodeWrapperService) {
    super();
  }

  physicianTypeEmpty$ = this.service
    .apiV1CodeCodetypePost('PhysicianType', { generalSearch: '', pageSize: 500 })
    .pipe(shareReplay(1));

  mapRow(result) {
    return {
      value: result.id,
      label: result.name
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    if (value === '') {
      return this.physicianTypeEmpty$.pipe(map((results) => results.data.map(this.mapRow)));
    }

    return this.service
      .apiV1CodeCodetypePost('PhysicianType', {
        generalSearch: value
      })
      .pipe(map((results) => results.data.map(this.mapRow)));
  }
}
